import CustomIcons from "../GlobalComponents/CustomIcons";
import React, { Component } from "react";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import Auth from "../../models/Auth";

class Carruselv2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      images: [],
      currentImageHeight: "auto",
      windowWidth: window.innerWidth,
    };
    this.autoSlideInterval = null;
    this.imageRefs = [];
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    this.obtenerImagenesCarrusel();

    this.autoSlideInterval = setInterval(() => {
      this.setState(
        (prevState) => ({
          currentIndex:
            prevState.currentIndex === this.state.images.length - 1
              ? 0
              : prevState.currentIndex + 1,
        }),
        this.updateContainerHeight
      );
    }, 10000);

    window.addEventListener("resize", this.handleResize);
  }

  touchStartX = 0;
  touchEndX = 0;

  handleTouchStart = (e) => {
    this.touchStartX = e.touches[0].clientX;
  };

  handleTouchMove = (e) => {
    this.touchEndX = e.touches[0].clientX;
  };

  handleTouchEnd = () => {
    const distance = this.touchStartX - this.touchEndX;
    const minSwipeDistance = 50;

    if (distance > minSwipeDistance) {
      this.handleNext();
    } else if (distance < -minSwipeDistance) {
      this.handlePrev();
    }
  };


  componentDidUpdate(prevProps, prevState) {
    // Asegúrate de que front_modules esté disponible en props antes de intentar acceder a él
    if (prevProps.front_modules && this.props.front_modules && prevProps.front_modules !== this.props.front_modules) {
        this.obtenerImagenesCarrusel();
    }

    if (
      prevState.currentIndex !== this.state.currentIndex ||
      prevState.windowWidth !== this.state.windowWidth
    ) {
      this.updateContainerHeight();
    }
    if (prevState.images.length === 0 && this.state.images.length > 0) {
      this.updateContainerHeight();
    }
  }

  componentWillUnmount() {
    clearInterval(this.autoSlideInterval);
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.setState({
      windowWidth: window.innerWidth,
    });
  }

  obtenerImagenesCarrusel = async () => {
    try {
      // Asegúrate de que this.props.front_modules tenga datos antes de intentar usarlos
      if (this.props.front_modules && this.props.front_modules.modules) {
        this.processModules(this.props.front_modules.modules);
      }
    } catch (e) {
      console.error("Error al obtener imágenes del carrusel:", e);
      this.setState({ images: [] }); // Asegura que images esté vacío en caso de error
    }
  };

  processModules = (modules) => {
    let arrImages = [];
    modules.forEach((module) => { // Usar forEach en lugar de map si no necesitas un nuevo array
      if (module.module_type === "Slider") {
        arrImages.push(module);
      }
    });

    arrImages.sort(function (a, b) {
      return a.extra_properties.position - b.extra_properties.position;
    });

    this.setState(
      {
        images: arrImages,
      },
      this.updateContainerHeight
    );
  };

  handlePrev = () => {
    this.setState((prevState) => ({
      currentIndex:
        prevState.currentIndex === 0
          ? this.state.images.length - 1
          : prevState.currentIndex - 1,
    }));
  };

  handleNext = () => {
    this.setState((prevState) => ({
      currentIndex:
        prevState.currentIndex === this.state.images.length - 1
          ? 0
          : prevState.currentIndex + 1,
    }));
  };

  updateContainerHeight = () => {
    if (this.imageRefs[this.state.currentIndex]) {
      const img = this.imageRefs[this.state.currentIndex];
      if (img.complete) {
        this.setState({ currentImageHeight: img.offsetHeight });
      } else {
        img.onload = () => {
          this.setState({ currentImageHeight: img.offsetHeight });
        };
      }
    } else {
      this.setState({ currentImageHeight: "auto" });
    }
  };

  element = () => {
    const { currentIndex, images, currentImageHeight, windowWidth } =
      this.state;

    const MOBILE_BREAKPOINT = 768;

    return (
      <div
        className="carrusel_container"
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
        style={{
          height:
            currentImageHeight !== "auto" ? `${currentImageHeight}px` : "auto",
        }}
      >
        <div
          className="items_container_cr"
          style={{
            width: `${this.state.images.length * 100}vw`,
            transform: `translateX(-${currentIndex * 100}vw)`,
            transition: "transform 0.5s ease-in-out",
          }}
        >
          {images.map((item, index) => {
            const imageUrl =
              windowWidth < MOBILE_BREAKPOINT
                ? item.extra_properties.image_mobile
                : item.image_link;

            // Determina si este es el slide activo para aplicar la clase CSS
            const textContainerClasses = `text-container-cr ${index === currentIndex ? 'active' : ''}`;

            return (
              <div
                onClick={() => {
                  if (item.redirect_link) {
                    window.open(item.redirect_link, "_blank");
                  }
                }}
                key={index}
                className="item-cr"
              >
                <img
                  src={imageUrl}
                  alt={item.title}
                  ref={(el) => (this.imageRefs[index] = el)}
                  onLoad={
                    index === currentIndex
                      ? this.updateContainerHeight
                      : undefined
                  }
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
                {/* Aplica la clase condicionalmente aquí */}
                <div className={textContainerClasses}>
                  <h1 className="title">{item.title}</h1>
                  <p className="description">{item.content}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Arrows */}
        <button onClick={this.handlePrev} className="arrow arrow-left-cr">
          <CustomIcons icon="arrowLeft" />
        </button>
        <button onClick={this.handleNext} className="arrow arrow-right-cr">
          <CustomIcons icon="arrowRight" />
        </button>

        {/* Indicators */}
        <div className="indicators-container">
          {this.state.images.map((_, index) => (
            <div
              key={index}
              className={
                index === currentIndex ? "indicator-selected" : "indicator"
              }
            />
          ))}
        </div>
      </div>
    );
  };

  render() {
    return Auth.notAuthenticationRequired(this.element());
  }
}

export default Carruselv2;